module.exports = __webpack_public_path__ + "img/lighthouse.0c4d17b2.png";